import { svg } from 'lit';

const symbol = svg`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none"><path d="M8 1v14" stroke="currentcolor" stroke-linejoin="bevel"/><path d="M13.018 6L8 1 2.983 6" stroke="currentcolor"/></svg>`;

export { symbol as default };
